import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import FeatherIcon from "feather-icons-react";
import { Button } from "../buttons/buttons";

// Spolocna pata pre formulare v modaloch a na detailoch.
//
// Preco vznikla: krizik na zatvorenie okna je maly a nie je z neho zrejme,
// ci sa zmeny ulozia alebo zahodia, a ulozenie bolo oby.cajne tlacidlo stratene
// v tele formulara. Teraz je dole pruh, ktory drzi dve jasne moznosti:
// zavriet bez zmeny a ulozit zmeny. Ulozenie je vyrazne a vzdy vpravo.
const Pruh = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin: 24px -20px -16px;
  padding: 16px 20px;
  border-top: 1px solid #e3e6ef;
  background: #fafbfc;
  border-radius: 0 0 10px 10px;
  flex-wrap: wrap;

  .ant-btn {
    height: 44px;
    padding: 0 22px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  /* Ulozenie ma byt vidno na prvy pohlad, nie splynut s formularom. */
  .ps-ulozit.ant-btn {
    box-shadow: 0 6px 16px rgba(95, 99, 242, 0.35);
  }

  /* Na mobile su pod sebou a cez celu sirku, nech sa do nich da trafit. */
  @media only screen and (max-width: 575px) {
    flex-direction: column-reverse;
    align-items: stretch;
    gap: 10px;

    .ant-btn {
      width: 100%;
      justify-content: center;
    }
  }
`;

const PataFormulara = ({
  onZrusit,
  textUlozit = "Uložiť zmeny",
  textZrusit = "Zavrieť bez zmeny",
  nacitava = false,
  vlastne = null,
}) => (
  <Pruh>
    {vlastne}
    {onZrusit && (
      <Button type="white" size="default" onClick={onZrusit} htmlType="button">
        <FeatherIcon icon="x" size={16} />
        {textZrusit}
      </Button>
    )}
    <Button
      className="ps-ulozit"
      htmlType="submit"
      type="primary"
      size="default"
      loading={nacitava}
    >
      <FeatherIcon icon="save" size={16} />
      {textUlozit}
    </Button>
  </Pruh>
);

PataFormulara.propTypes = {
  onZrusit: PropTypes.func,
  textUlozit: PropTypes.string,
  textZrusit: PropTypes.string,
  nacitava: PropTypes.bool,
  vlastne: PropTypes.node,
};

export { PataFormulara };
export default PataFormulara;
